export default __webpack_public_path__ + "static/media/blog-img87.2acd3722.jpg";